import { getSupabaseBrowserClient } from "@/lib/supabase/client";
import {
  EMPTY_SEARCH_RESULTS,
  type PlatformSearchHit,
  type PlatformSearchResults,
} from "@/lib/search/types";
import { asArray } from "@/lib/utils";

function asHit(value: unknown): PlatformSearchHit | null {
  if (!value || typeof value !== "object") {
    return null;
  }

  const row = value as Record<string, unknown>;
  if (
    typeof row.id !== "string" ||
    typeof row.title !== "string" ||
    typeof row.href !== "string" ||
    row.title.trim().length === 0
  ) {
    return null;
  }

  return {
    id: row.id,
    title: row.title.trim(),
    subtitle: typeof row.subtitle === "string" ? row.subtitle : null,
    href: row.href,
  };
}

function asHits(value: unknown): PlatformSearchHit[] {
  return asArray(value).map(asHit).filter((hit): hit is PlatformSearchHit => Boolean(hit));
}

export async function searchPlatform(
  query: string,
): Promise<PlatformSearchResults> {
  const normalized = query.trim();
  if (normalized.length < 2) {
    return EMPTY_SEARCH_RESULTS;
  }

  const supabase = getSupabaseBrowserClient();
  const { data, error } = await supabase.rpc("search_platform", {
    search_query: normalized,
  });

  if (error) {
    throw error;
  }

  const payload =
    data && typeof data === "object" ? (data as Record<string, unknown>) : {};

  return {
    posts: asHits(payload.posts),
    communities: asHits(payload.communities),
    members: asHits(payload.members),
  };
}
